import React from 'react';

const GoodGovernanceHeader = () => {
    return(
        <>
            <section class="intro-about section-margin" style={{marginBottom: '0px'}}>
                    <div class="container" style={{paddingBottom: '50px'}}>
                        <div class="row">
                            <div class="col-lg-12">
                                <div class="intro-content-text" style={{paddingTop: '90px'}}>

                                    <h2 data-dsn-grid="move-section" data-dsn-move="-30" data-dsn-duration="100%"
                                        data-dsn-opacity="1.2" data-dsn-responsive="tablet" style={{color:'#000', textAlign: 'center'}}>
                                       Good Governance
                                    </h2>

                                    <p class="economy-page-header-desc" style={{fontSize: '1rem', fontWeight: '500', maxWidth:'100%', color:'#000', textAlign: 'center', paddingLeft: '80px', paddingRight: '80px'}}>
                                    Sikkim has made its mark as a model state due to the good governance of the Pawan Chamling led SDF government. With momentous achievements in sectors from environment to industry, Sikkim has gained a reputation as the most progressive and innovative state in the country.
                                    </p>


                                </div>
                            </div>

                        </div>
                    </div>

                </section>
        </>
    );
};

export default GoodGovernanceHeader;